import { connect } from 'react-redux';
import GenericConfirmationModal from './GenericConfirmationModal';
import { getModals } from '../../../store/modals/selectors';
import { setOpenModal } from '../../../store/modals/actions';

const mapStateToProps = (state) => ({
  modals: getModals(state),
});

const mapDispatchToProps = (dispatch) => ({
  setOpenModal: (modal, value) => dispatch(setOpenModal(modal, value)),

});

export default connect(mapStateToProps, mapDispatchToProps)(GenericConfirmationModal);
